export default {
  timePlaceholder: 'hh:mm',
};
